import { Token } from "./Token";
import jwtDecode from "jwt-decode";
export class TokensManager {
    storage;
    tokens = {
        access: null,
        refresh: null,
    };
    constructor(storage) {
        this.storage = storage;
    }
    set(type, value) {
        this.tokens[type] = value !== null ? new Token(type, value) : null;
        if (value === null) {
            this.storage.remove(type);
        }
        else {
            this.storage.set(type, value);
        }
    }
    get access() {
        return this.tokens.access;
    }
    get refresh() {
        return this.tokens.refresh;
    }
    setAccess(value) {
        this.set("access", value);
    }
    setRefresh(value) {
        this.set("refresh", value);
    }
    isValid(value) {
        try {
            jwtDecode(value);
            return true;
        }
        catch (e) {
            return false;
        }
    }
    sync() {
        const access = this.storage.get("access");
        const refresh = this.storage.get("refresh");
        this.setAccess(this.isValid(access) ? access : null);
        this.setRefresh(this.isValid(refresh) ? refresh : null);
    }
    cleanOut() {
        this.setAccess(null);
        this.setRefresh(null);
    }
}
